import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import EditEmailPage from '@/features/account/profile/edit-email';
import { IdentityRouteGuard } from '@/features/account/identity-confirmation';

export const Route = createFileRoute('/perfil/editar/email')({
  component: () => (
    <HomeGate>
      <IdentityRouteGuard target="email">
        <EditEmailPage />
      </IdentityRouteGuard>
    </HomeGate>
  ),
});
